import { createDeployPluginHeadless } from '../../_shared/common/createDeployPluginHeadless';
import { VM_CAPABILITIES } from '../capabilities';
import { VM_FIELD_KEYS } from '../fields';
import { VM_MODULES } from '../modules';
import { vmMigrations } from './migrations';
import { buildVmDisplayDescriptors, buildVmResourceConfigs, pickVmPresetFields, serializeVmApiBody } from './projections';
import { type VmApiPayload, type VmSpec, VmSpecSchema } from './schema';
import { vmFromForm, vmGetInitialFormValues, vmToForm } from './spec';

export const vmHeadless = createDeployPluginHeadless<VmSpec, VmApiPayload, (typeof VM_FIELD_KEYS)[number]>({
  code: 'VirtualMachine',
  fieldKeys: VM_FIELD_KEYS,
  modules: VM_MODULES,
  capabilities: VM_CAPABILITIES,
  schema: VmSpecSchema,
  fromForm: vmFromForm,
  toForm: vmToForm,
  getInitialFormValues: vmGetInitialFormValues,
  projectionProfile: {
    profile: 'sku-capable',
    projections: {
      apiBody: serializeVmApiBody,
      skuPreset: pickVmPresetFields,
      buildDisplayDescriptors: buildVmDisplayDescriptors,
      skuResources: buildVmResourceConfigs,
    },
  },
  migrations: vmMigrations,
});

export const vmPipeline = vmHeadless.pipeline;

export { buildVmDeliveryMetadata, buildVmOrderDeliveryMetadata } from './deliveryMetadata';
export type {
  BuildVmDeliveryMetadataInput,
  BuildVmOrderDeliveryMetadataContext,
  VmCpuInfo,
  VmDeliveryMetadata,
  VmGpuInfo,
  VmNetworkInfo,
  VmResourceInfo,
  VmSystemInfo,
} from './deliveryMetadata';
